import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';

// Cacher le splash screen natif dès que React est monté
async function hideSplash() {
  if (Capacitor.isNativePlatform()) {
    try {
      const { SplashScreen } = await import('@capacitor/splash-screen');
      await SplashScreen.hide({ fadeOutDuration: 500 });
    } catch { /* ignore si plugin non dispo */ }
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Element #root introuvable dans index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Cacher le splash après le rendu
hideSplash();
